import { View } from 'backbone.marionette';
import Backbone from 'backbone';
import _ from 'lodash';

import OrderDeviceCollectionView from '../OrderDeviceCollectionView';
import OrderDeviceAdminCollectionView from '../OrderDeviceAdminCollectionView';

import tmplDefaultDeviceSectionView from './DefaultDeviceSectionView.hbs';

// import './PRTNRDeviceSectionView.css';

const DefaultDeviceSectionView = View.extend({
  template: tmplDefaultDeviceSectionView,

  className: 'default-device-section-view',

  ui: {
    vb1MonoCollection: '.vb1-mono-collection',
    vb1ColorCollection: '.vb1-color-collection',
    vb2MonoCollection: '.vb2-mono-collection',
    vb2ColorCollection: '.vb2-color-collection',
    vb3MonoCollection: '.vb3-mono-collection',
    vb3ColorCollection: '.vb3-color-collection',
    vb4MonoCollection: '.vb4-mono-collection',
    vb4ColorCollection: '.vb4-color-collection',
    vb5MonoCollection: '.vb5-mono-collection',
    accessoriesCollection: '.accessories-collection',
    servicesCollection: '.services-collection',
    toggle: '.toggle'
  },

  regions: {
    vb1MonoCollection: '@ui.vb1MonoCollection',
    vb1ColorCollection: '@ui.vb1ColorCollection',
    vb2MonoCollection: '@ui.vb2MonoCollection',
    vb2ColorCollection: '@ui.vb2ColorCollection',
    vb3MonoCollection: '@ui.vb3MonoCollection',
    vb3ColorCollection: '@ui.vb3ColorCollection',
    vb4MonoCollection: '@ui.vb4MonoCollection',
    vb4ColorCollection: '@ui.vb4ColorCollection',
    vb5MonoCollection: '@ui.vb5MonoCollection',
    accessoriesCollection: '@ui.accessoriesCollection',
    servicesCollection: '@ui.servicesCollection'
  },

  events: {
    'click @ui.toggle': 'onClickToggle'
  },

  templateContext() {
    return {
      hasAccessories: _.filter(this.model.get('lineItems'), { isAdditionalAccessory: '1' }).length > 0,
      hasServices: _.filter(this.model.get('lineItems'), { isAdditionalService: '1' }).length > 0
    };
  },

  collection: null,

  onClickToggle() {
    const id = this.model.get('id').concat('-caret');
    const caret = document.getElementById(id);
    if (caret.classList.contains('fa-caret-down')) {
      caret.classList.remove('fa-caret-down');
      caret.classList.add('fa-caret-up');
    } else if (caret.classList.contains('fa-caret-up')) {
      caret.classList.remove('fa-caret-up');
      caret.classList.add('fa-caret-down');
    }
  },

  onRender() {
    const lineItems = this.model.get('lineItems');

    this.collection = new Backbone.Collection([]);
    const collections = {
      vb1MonoCollection: {
        collection: new Backbone.Collection([]),
        items: _.filter(lineItems, { isColor: '0', speedPPM: '25' })
      },
      vb1ColorCollection: {
        collection: new Backbone.Collection([]),
        items: _.filter(lineItems, { isColor: '1', speedPPM: '25' })
      },
      vb2MonoCollection: {
        collection: new Backbone.Collection([]),
        items: _.filter(lineItems, { isColor: '0', speedPPM: '35' })
      },
      vb2ColorCollection: {
        collection: new Backbone.Collection([]),
        items: _.filter(lineItems, { isColor: '1', speedPPM: '35' })
      },
      vb3MonoCollection: {
        collection: new Backbone.Collection([]),
        items: _.filter(lineItems, { isColor: '0', speedPPM: '45' })
      },
      vb3ColorCollection: {
        collection: new Backbone.Collection([]),
        items: _.filter(lineItems, { isColor: '1', speedPPM: '45' })
      },
      vb4MonoCollection: {
        collection: new Backbone.Collection([]),
        items: _.filter(lineItems, { isColor: '0', speedPPM: '50' })
      },
      vb4ColorCollection: {
        collection: new Backbone.Collection([]),
        items: _.filter(lineItems, { isColor: '1', speedPPM: '50' })
      },
      vb5MonoCollection: {
        collection: new Backbone.Collection([]),
        items: _.filter(lineItems, { isColor: '0', speedPPM: '60' })
      },
      accessoriesCollection: {
        collection: new Backbone.Collection([]),
        items: _.filter(lineItems, { isAdditionalAccessory: '1' })
      },
      servicesCollection: {
        collection: new Backbone.Collection([]),
        items: _.filter(lineItems, { isAdditionalService: '1' })
      }
    };

    _.each(Object.entries(collections), ([collectionName, collectionObj]) => {
      const { collection, items } = collectionObj;
      this.populateCollection(collection, items);
      if (collection.length > 0) {
        this.showChildCollection(collectionName, collection);
      }
    });
  },

  getDeviceData() {
    const changedItems = [];
    const lineItems = this.model.get('lineItems');
    let totalPrice = 0;
    let totalQuantity = 0;

    _.each(this.collection.models, (model) => {
      const item = _.find(lineItems, { id: model.id });
      if (model.get('quantity') !== '0') {
        totalPrice += model.get('totalPrice');
        totalQuantity += parseInt(model.get('quantity'));
      }
      if (model.get('quantity') !== item.quantity) {
        changedItems.push(model.attributes);
      }
    });
    const savedData = {
      changedItems,
      totalPrice,
      totalQuantity
    };
    return savedData;
  },

  showChildCollection(region, coll) {
    if (this.model.get('isAdminEdit')) {
      this.showChildView(
        region,
        new OrderDeviceAdminCollectionView({
          collection: coll,
          contract: this.model.get('contract')
        })
      );
    } else {
      this.showChildView(
        region,
        new OrderDeviceCollectionView({
          collection: coll,
          contract: this.model.get('contract')
        })
      );
    }
  },

  populateCollection(collection, items) {
    _.each(items, (item) => {
      const dev = new Backbone.Model(item);
      collection.add(dev);
      this.collection.add(dev);
    });
    return collection;
  }
});

export default DefaultDeviceSectionView;
